import { render, staticRenderFns } from "./EnquireDispatch.vue?vue&type=template&id=4ed9f431&scoped=true"
import script from "./EnquireDispatch.vue?vue&type=script&lang=ts"
export * from "./EnquireDispatch.vue?vue&type=script&lang=ts"
import style0 from "./EnquireDispatch.vue?vue&type=style&index=0&id=4ed9f431&prod&lang=css"
import style1 from "./EnquireDispatch.vue?vue&type=style&index=1&id=4ed9f431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9f431",
  null
  
)

export default component.exports